import { useEffect, useState } from "react";
import { IconSelected, IconArrow } from "@/components/icon/master";
import { DdpCta } from "@/components/shared/DdpCta";
import { useAppStore, useCmsStore } from "@/components/AppHooks";
import { useRouter } from "next/navigation";
import { TopBack } from "@/components/shared/TopBack";
import { PopupQuizChooseAlcohol } from "./popup-quiz-choose-alcohol";
import { PopupQuizTimeReminder } from "./popup-quiz-time-reminder";
import { TQuizProps } from "../type";
import { DdpImage } from "@/components/shared/DdpImage";
import { TDdpMedia } from "@/shared/types";
import { styleName } from "@/config/const";
import { isCurrentTimeInDailyRangeIgnoreTimezone, UtilPrevBack } from "@/shared/utils";
import { SimnoffTopMarquee } from "@/components/shared/Smirnoff/TopMarquee";
import { tracking } from "@/shared/tracking";
export function QuizMaster(props: TQuizProps) {
    const { locale, storeConfig } = useCmsStore()!
    const {
        storeStyleName, nonAlcoholStore, startTime, endTime
    } = storeConfig
    const { questionAtmosphere, atmosphere, sideImageAtmosphere, questionFood, choosePromptLabelFood, continueCTAFood, popupSelection, popupNonAlcoholic } = props
    const isSmirnoffKenya = storeStyleName === styleName.SmirnoffKenya
    const _cta = (Array.isArray(continueCTAFood) ? continueCTAFood[0] : continueCTAFood)
    const _continueCTAFood = {
        ..._cta,
        url: isSmirnoffKenya ? _cta.url : ``,
    }
    const router = useRouter()
    const { answer, setAnswer, resetAnswer, setAlcohol } = useAppStore();
    const hasNonAlcoholStore = nonAlcoholStore?.id && nonAlcoholStore.cocktailList?.length > 0
    useEffect(() => {
        if (!hasNonAlcoholStore || storeStyleName === styleName.SmirnoffKenya) {
            setAlcohol(true)
        }
        //默认饮酒的情况需要setAlcohol(true)
    }, [storeStyleName])
    const [showTimePopup, setShowTimePopup] = useState(false)
    const [showChooseAlcoholPopup, setShowChooseAlcoholPopup] = useState(false)
    function handleNext() {
        // 在store level允许添加和编辑含酒精不含酒精的popup, 和酒精限制时间popup 捆绑设置，如果不设置时间则只显示第一个选项popup, 不显示reminder。
        if (hasNonAlcoholStore && storeStyleName === styleName.Master) {
            if (startTime && endTime && isCurrentTimeInDailyRangeIgnoreTimezone(startTime, endTime)) {//设置了时间或者没设置时间 取store config
                setAlcohol(false)
                setShowTimePopup(true)
                return
            }
            setShowChooseAlcoholPopup(true)
        } else {
            router.push(`/${locale}/results${location.search}`)
        }
    }

    return <div className={`${isSmirnoffKenya ? 'page-smirnoff-quiz' : 'page-quiz page-container'}`}>
        {
            isSmirnoffKenya && <SimnoffTopMarquee />
        }
        <div className="smirnoff-page-container">
            <div className="left-content">
                <div className="top-wrapper">
                    <TopBack onClick={() => {
                        if (answer.atmosphere) {
                            resetAnswer()
                        } else {
                            // if (!hasPrevPath()) {
                            //     const params = new URLSearchParams(location.search);
                            //     params.delete('cocktailId');
                            //     params.delete('noResult');
                            //     const query = params.toString();
                            //     router.replace(`/${GetLocale()}/home${query ? '?' + query : ''}`)
                            //     return
                            // }
                            UtilPrevBack().then((res) => {
                                if (res) {
                                    router.back()
                                }
                            })
                        }
                    }} />
                    <h1 className="title">{answer.atmosphere ? questionFood : questionAtmosphere}</h1>
                    {answer.atmosphere && <div className="cta-wrapper sm:hidden desk:flex"> <DdpCta className={`cta-next`} disabled={answer.recipes.length < 3} cta={_continueCTAFood} onClick={handleNext} >
                        {isSmirnoffKenya && <IconArrow right />}
                    </DdpCta></div>
                    }
                </div>
                <div className="atmosphere-wrapper">
                    {answer?.atmosphere ?
                        <div className="food-wrapper">
                            <div className="atmosphere-desc">{choosePromptLabelFood}</div>
                            <div className="food-list" onClick={(e) => {
                                const foodItem = (e.target as HTMLElement).closest('.food-item')
                                if (foodItem) {
                                    const foodId = (foodItem as HTMLElement).dataset.food as string
                                    if (answer.recipes.includes(foodId)) {
                                        setAnswer({
                                            ...answer,
                                            recipes: [...answer.recipes.filter(item => item !== foodId)],
                                        })
                                    } else {
                                        setAnswer({
                                            ...answer,
                                            recipes: [...answer.recipes, foodId],
                                        })
                                    }
                                }
                            }}>
                                {
                                    atmosphere.find((item) => item.atmosphereID === answer?.atmosphere)?.foodList.map((item: {
                                        foodID: string,
                                        foodName: string,
                                        backgroundImage: Array<TDdpMedia>,
                                    }) => {
                                        return <div className={`food-item ${answer?.recipes.includes(item.foodID) ? 'selected' : ''}`} key={item.foodID} data-food={item.foodID} >
                                            <div className="food-media-wrapper">
                                                <DdpImage className="food-img" image={item.backgroundImage} />
                                                <div className="mask"></div>
                                                <IconSelected className="selected-icon" />
                                            </div>
                                            <div className="food-text">{item.foodName}</div>
                                        </div>
                                    })
                                }
                            </div>
                        </div> : <div className="atmosphere-list">
                            {atmosphere.map((item, index) => {
                                // console.log('item:', item)
                                // const IconCompoennt = IconVibes[index]
                                return <div key={`atmosphere-${index}`} className="atmosphere-item" onClick={() => {
                                    setAnswer({
                                        atmosphere: item.atmosphereID,
                                        atmosphereName: item.atmosphereName,
                                        recipes: [],
                                    })
                                    tracking({
                                        "event": "custom_event",
                                        "event_name": "quiz_step",
                                        "step": "question 2"
                                    })
                                }}>
                                    <div className="atmosphere-media-wrapper">
                                        <DdpImage className="atmosphere-media" image={item.backgroundImage} />
                                        {
                                            item?.icon?.url && <div className="svg-wrapper">
                                                <img className="svg-icon" src={item?.icon?.url} />
                                            </div>
                                        }
                                    </div>
                                    <div className="atmosphere-text" dangerouslySetInnerHTML={{ __html: item.atmosphereName }}></div>
                                </div>
                            }
                            )}
                        </div>
                    }
                </div>
                {answer.atmosphere && <div className="cta-wrapper sm:flex desk:hidden">
                    <div className="atmosphere-desc">{choosePromptLabelFood}</div>
                    <DdpCta className={`cta-next `} disabled={answer.recipes.length < 3} cta={_continueCTAFood} onClick={handleNext} >
                        {isSmirnoffKenya && <IconArrow right />}
                    </DdpCta></div>
                }
            </div>
            <div className="right-media-wrapper">
                <DdpImage image={sideImageAtmosphere} className="right-media" />
            </div>
        </div>
        {
            popupNonAlcoholic && popupNonAlcoholic[0] && <PopupQuizTimeReminder content={popupNonAlcoholic[0]} show={showTimePopup} onClose={() => {
                setShowTimePopup(false)
            }} />
        }
        {
            popupSelection && popupSelection[0] && <PopupQuizChooseAlcohol content={popupSelection[0] || null} show={showChooseAlcoholPopup} onClose={() => {
                setAlcohol(undefined)
                setShowChooseAlcoholPopup(false)
            }} />
        }

    </div>
}